export const API_SUBMIT_REFUND_DISPUTE = 'SUBMIT_REFUND_DISPUTE' as const;
export const API_SUBMIT_REFUND_DISPUTE_REQUEST =
  'SUBMIT_REFUND_DISPUTE_REQUEST' as const;
export const API_SUBMIT_REFUND_DISPUTE_SUCCESS =
  'SUBMIT_REFUND_DISPUTE_SUCCESS' as const;
export const API_SUBMIT_REFUND_DISPUTE_FAILURE =
  'SUBMIT_REFUND_DISPUTE_FAILURE' as const;

export const API_GET_AVAILABLE_DISPUTE_REASONS =
  'GET_AVAILABLE_DISPUTE_REASONS' as const;
export const API_GET_AVAILABLE_DISPUTE_REASONS_REQUEST =
  'GET_AVAILABLE_DISPUTE_REASONS_REQUEST' as const;
export const API_GET_AVAILABLE_DISPUTE_REASONS_SUCCESS =
  'GET_AVAILABLE_DISPUTE_REASONS_SUCCESS' as const;
export const API_GET_AVAILABLE_DISPUTE_REASONS_FAILURE =
  'GET_AVAILABLE_DISPUTE_REASONS_FAILURE' as const;

export const API_FETCH_DISPUTE_STATUS_FOR_ORDER =
  'FETCH_DISPUTE_STATUS_FOR_ORDER' as const;
export const API_FETCH_DISPUTE_STATUS_FOR_ORDER_REQUEST =
  'FETCH_DISPUTE_STATUS_FOR_ORDER_REQUEST' as const;
export const API_FETCH_DISPUTE_STATUS_FOR_ORDER_SUCCESS =
  'FETCH_DISPUTE_STATUS_FOR_ORDER_SUCCESS' as const;
export const API_FETCH_DISPUTE_STATUS_FOR_ORDER_FAILURE =
  'FETCH_DISPUTE_STATUS_FOR_ORDER_FAILURE' as const;

export const API_FETCH_REFUND_DISPUTES = 'FETCH_REFUND_DISPUTES' as const;
export const API_FETCH_REFUND_DISPUTES_REQUEST =
  'FETCH_REFUND_DISPUTES_REQUEST' as const;
export const API_FETCH_REFUND_DISPUTES_SUCCESS =
  'FETCH_REFUND_DISPUTES_SUCCESS' as const;
export const API_FETCH_REFUND_DISPUTES_FAILURE =
  'FETCH_REFUND_DISPUTES_FAILURE' as const;

export const UPDATE_SELECTED_DISPUTE_REASONS =
  'UPDATE_SELECTED_DISPUTE_REASONS' as const;
export const COMBINE_ORDER_AND_REFUNDED_ORDER =
  'COMBINE_ORDER_AND_REFUNDED_ORDER' as const;
export const RESET_SELECTED_DISPUTE_REASONS =
  'RESET_SELECTED_DISPUTE_REASONS' as const;
export const UPDATE_CURRENT_ORDER_ID = 'UPDATE_CURRENT_ORDER_ID' as const;
